import { ViewTypes } from '@23degrees/shared-code/config/constants';
import { Content } from '@23degrees/shared-code/models';
import { FavoritesService } from '@23degrees/shared/services/content/favorites.service';
import { Injectable, inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { take, tap } from 'rxjs/operators';
import { FavoritesStore } from './favorites.store';

@Injectable({ providedIn: 'root' })
export class FavoritesStoreService {
  types = ViewTypes.map((viz) => viz.type);

  private favoritesStore: FavoritesStore = inject(FavoritesStore);
  private favoritesService: FavoritesService = inject(FavoritesService);
  private notificationService: NotificationsService = inject(NotificationsService);

  get() {
    this.favoritesService.myFavorites(0, 999, this.types).subscribe((entities) => {
      this.favoritesStore.set(entities);
    });
  }

  add(content: Content, silent: boolean = false) {
    this.favoritesService
      .addFavorite(content)
      .pipe(
        take(1),
        tap(() => {
          // this.favoritesStore.add(content);
          // TODO: @Manfred needs further enhancement cause favorite content stays on this state
          this.favoritesStore.add(JSON.parse(JSON.stringify(content)));
          if (!silent) {
            this.notificationService.success('Added to favorites', content.fileName);
          }
        })
      )
      .subscribe();
  }

  update(content: Content) {
    this.favoritesStore.update(content._id, content);
  }

  updateContent(id, options) {
    this.favoritesStore.update(id, options);
  }

  remove(content: Content, silent: boolean = false) {
    this.favoritesService
      .removeFavorite(content._id)
      .pipe(
        take(1),
        tap(() => {
          this.favoritesStore.remove(content._id);
          if (!silent) {
            this.notificationService.success('Removed from favorite', content.fileName);
          }
        })
      )
      .subscribe();
  }
}
